export default (modifiers) => Object.keys(modifiers).reduce((classesString, modifier) => {
    classesString = `${classesString} app_${modifier}_${modifiers[modifier]}`
    return classesString
}, '')
